import { render, staticRenderFns } from "./GradingPlanChangeActivationType.vue?vue&type=template&id=23d8716f&"
import script from "./GradingPlanChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./GradingPlanChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports